import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, CircularProgress, Alert, Button, Box } from "@mui/material";
import customHttp from "../../services/customHTTP";
import PageTitle from "../../components/PageTitle/PageTitle";
import "./OrderConfirmation.css"; // Import the custom CSS file
import { TaskAltOutlined } from "@mui/icons-material";

import { useAuth } from "../../context/authContext";
import OrderDetails from "../../components/OrderDetails/OrderDetails";

const OrderConfirmation = () => {
	const { orderKey } = useParams();
	const { user } = useAuth();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [orderData, setOrderData] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchOrder = async () => {
			try {
				const req_body = { orderKey };
				const response = await customHttp.post("/orders/getOrderByKey", req_body);

				if (response.data && response.data.success) {
					const orderDetails = response.data.data;

					setOrderData(orderDetails);
				} else {
					setError(response.data.message || "An error occurred while fetching the order.");
				}
			} catch (error) {
				console.error("Error while fetching the order", error);
				setError("An error occurred while fetching the order. Please try again.");
			} finally {
				setLoading(false);
			}
		};
		fetchOrder();
	}, [orderKey]);

	if (loading) return <CircularProgress />;
	if (error)
		return (
			<Alert severity="error" className="error-alert">
				{error}
			</Alert>
		);
	if (!orderData) return null;

	const { order } = orderData;

	const handleViewAllOrders = () => {
		navigate("/order-history");
	};

	const handleContinueRequests = () => {
		navigate("/requests");
	};

	return (
		<div className="order-confirmation-container">
			<PageTitle title="Quote Confirmation" />

			<div className="confirmation-container">
				<div className="icon">
					<TaskAltOutlined sx={{ width: "100%", height: "50px" }} />
				</div>
				<div className="text">
					<Typography variant="h5" sx={{ fontWeight: "bold" }}>
						Quote Submitted! Thank You, {user.user_first_name}
					</Typography>
					<Typography variant="body1">Quote #: {order.order_number}</Typography>
				</div>
			</div>
			<Typography variant="body1" sx={{ mt: 2, px: 1 }}>
				An email with the quote details will be sent to your registered email. Once the quote is Confirmed, You
				will be Notified.
			</Typography>
			<OrderDetails orderData={orderData} />

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					padding: "20px",
					columnGap: "12px",
				}}>
				<Button variant="contained" color="primary" className="button-primary" onClick={handleContinueRequests}>
					Continue to Requests
				</Button>
				<Button variant="contained" color="primary" className="button-primary" onClick={handleViewAllOrders}>
					View All Quotes
				</Button>
			</Box>
		</div>
	);
};

export default OrderConfirmation;
